/**
 * Source-link registration rows (T026). Repo / PM board / Clockify project / Drive doc.
 * The `channel` kind (area + has_client) is added in US4 (ChannelMapper). Controlled component.
 */
import { useState } from 'react';
import type { SourceLinkKind } from '../types/entities';
import type { SourceLinkInput } from '../services/onboarding';

const US1_KINDS: { value: SourceLinkKind; label: string }[] = [
  { value: 'github_repo', label: 'GitHub repo' },
  { value: 'pm_board', label: 'PM board' },
  { value: 'clockify_project', label: 'Clockify project' },
  { value: 'drive_doc', label: 'Drive doc' },
];

export function SourceLinks({
  value,
  onChange,
  disabled,
}: {
  value: SourceLinkInput[];
  onChange: (next: SourceLinkInput[]) => void;
  disabled?: boolean;
}) {
  const [kind, setKind] = useState<SourceLinkKind>('github_repo');
  const [externalId, setExternalId] = useState('');

  const add = () => {
    if (!externalId.trim()) return;
    onChange([...value, { kind, external_id: externalId.trim() }]);
    setExternalId('');
  };

  const remove = (i: number) => onChange(value.filter((_, idx) => idx !== i));

  return (
    <fieldset disabled={disabled} style={{ border: '1px solid #ddd', padding: 12 }}>
      <legend>Sources</legend>

      <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
        <select value={kind} onChange={(e) => setKind(e.target.value as SourceLinkKind)}>
          {US1_KINDS.map((k) => (
            <option key={k.value} value={k.value}>
              {k.label}
            </option>
          ))}
        </select>
        <input
          placeholder="repo URL / board key / clockify id / drive link"
          value={externalId}
          onChange={(e) => setExternalId(e.target.value)}
          style={{ flex: 1 }}
        />
        <button type="button" onClick={add}>
          Add
        </button>
      </div>

      <ul style={{ margin: 0, paddingLeft: 18 }}>
        {value.map((s, i) => (
          <li key={`${s.kind}-${s.external_id}-${i}`}>
            <code>{s.kind}</code> — {s.external_id}{' '}
            <button type="button" onClick={() => remove(i)}>
              remove
            </button>
          </li>
        ))}
        {value.length === 0 && <li style={{ listStyle: 'none', color: '#888' }}>No sources yet.</li>}
      </ul>
    </fieldset>
  );
}
